// @flow

import * as React from "react";
import { type LinkType } from "../../types";
import LinkHandler from "../atoms/LinkHandler";

type PropsType = {
    className?: string,
    list: [{ link: LinkType }],
};

const FooterLinkList = ({ className, list }: PropsType): React.Node => {
    const cssBaseClass = "footer-link-list";
    const classList = [cssBaseClass];
    if (className) {
        classList.push(className);
    }

    return (
        <ul className={classList.join(" ")}>
            {list
                ? list.map(({ link }, index): React.Node => {
                      return (
                          <li key={index}>
                              <LinkHandler to={link.url} target={link.target}>
                                  <span className="text">{link.title}</span>
                              </LinkHandler>
                          </li>
                      );
                  })
                : null}
        </ul>
    );
};

export default FooterLinkList;
